import { ArrayField } from 'react-hook-form';

import { DosagePeriod, DosageStageUnion, DosageTimeUnit } from '~libs.shared.prescription';

import { ExtendedDosageFormController } from '../ExtendedDosageForm.types';

import {
   BREAK_DURATION_DEFAULT,
   computeOrdinalNumbers,
   createStageFieldNameFactory,
   CYCLE_DURATION_DEFAULT,
   getStageDurationDays,
} from './StageFieldList.utils';

type UseStageFieldListOptions = Pick<ExtendedDosageFormController, 'watch'> & {
   fields: Partial<ArrayField<DosageStageUnion>>[];
};

type StageFieldListState = {
   ordinalNumbers: number[];
   stageClasses: Pick<DosageStageUnion, 'class'>[];
   durationDays: number[];
};

export const useStageFieldList = (options: UseStageFieldListOptions): StageFieldListState => {
   const durationDays = options.fields.map((field, index) => {
      const createFieldName = createStageFieldNameFactory(index);
      const defaults = field.class === 'DosageBreak' ? BREAK_DURATION_DEFAULT : CYCLE_DURATION_DEFAULT;
      const amount = Number(options.watch(createFieldName('duration.amount')) ?? defaults.amount);
      const unit = (options.watch(createFieldName('duration.unit')) as DosageTimeUnit | undefined) ?? defaults.unit;
      const duration: DosagePeriod = { amount: Number.isFinite(amount) ? amount : defaults.amount, unit: unit };

      return getStageDurationDays(duration);
   });

   return {
      ordinalNumbers: computeOrdinalNumbers(options.fields),
      stageClasses: options.fields.map((field) => ({ class: field.class! })),
      durationDays: durationDays,
   };
};
